import { fromJS } from 'immutable';

import handleDefault from '../handleDefault';

const initialState = fromJS({
  entities: {},
  users: [],
});

const ENTITY_IDENTIFIER = 'users';
export default function reducer(state = initialState, action) {
  switch (action.type) {
    default:
      return handleDefault(ENTITY_IDENTIFIER)(state, action);
  }
}

